import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_e185b7e9 from '../styles/Skeleton.module.less.js';

function validWidth(width) {
    if (!width || width < 0) {
        return 100;
    }
    if (width > 100) {
        return 100;
    }
    return width;
}
/**
 * @description Skeleton Paragraph component.
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton.Paragraph />
 * ```
 */
const Paragraph = (props) => {
    const { width, className, inverted = false, ...restProps } = props;
    const cx = useStyles(modules_e185b7e9);
    const classNames = cx(className, 'paragraph', { inverted });
    const elementStyles = {
        width: `${validWidth(width)}%`,
    };
    return React.createElement("div", { className: classNames, ...restProps, style: elementStyles });
};
Paragraph.displayName = 'Paragraph';

export { Paragraph };
//# sourceMappingURL=Paragraph.js.map
